import FroalaEditor from "froala-editor";
import 'froala-editor/js/plugins/colors.min.js';
import 'froala-editor/js/plugins/font_family.min.js';
import 'froala-editor/js/plugins/paragraph_format.min.js';
import 'froala-editor/js/plugins/font_size.min.js';
import 'froala-editor/js/plugins/line_height.min.js';
import 'froala-editor/js/plugins/link.min.js';
import 'froala-editor/js/plugins/align.min.js';
import "froala-editor/js/plugins/image.min.js";
import { buildMergeTagGroups } from "../../utils/mergeTagOptions";
import {
  isMergeTagChipPopoverOpen,
  openMergeTagChipPopover,
  openMergeTagPicker,
  removeMergeTagChip,
} from "../../components/shared/forms/MergeTagPicker";
import { chipifyMergeTags, unchipifyMergeTags } from "../../utils/mergeTagChips";

if (FroalaEditor && FroalaEditor.COMMANDS && FroalaEditor.COMMANDS.paragraphFormat) {
  FroalaEditor.RegisterCommand(
    "paragraphFormat",
    Object.assign({}, FroalaEditor.COMMANDS.paragraphFormat, {
      refreshOnShow: function ($btn, $dropdown) {
        let tag = "N";
        const blocks = this.selection.blocks();
        if (blocks.length) {
          const block = blocks[0];
          const defaultTag = this.html.defaultTag();
          if (block.tagName.toLowerCase() != (defaultTag || "") && block != this.el) {
            tag = block.tagName;
          }
        } else {
          const contentBlock = this.el.querySelector("h1, h2, h3, h4, h5, h6, pre");
          if (contentBlock) {
            tag = contentBlock.tagName;
          }
        }

        const dropdown = $dropdown && $dropdown.get ? $dropdown.get(0) : null;
        if (dropdown) {
          dropdown.querySelectorAll(".fr-active").forEach((el) => {
            el.classList.remove("fr-active");
            el.setAttribute("aria-selected", "false");
          });
          const target = dropdown.querySelector(
            '.fr-command[data-param1="' + tag + '"]'
          );
          if (target) {
            target.classList.add("fr-active");
            target.setAttribute("aria-selected", "true");
          }
        }
      },
    })
  );
}

var froalaExtend = function (website = null, fields = null, actions = null) {
  if (FroalaEditor) {

    FroalaEditor.DEFAULTS.paragraphFormat = {
      N: "Normal",
      H1: "Heading 1",
      H2: "Heading 2",
      H3: "Heading 3",
      H4: "Heading 4",
      H5: "Heading 5",
      H6: "Heading 6",
      PRE: "Code",
    };

    const mergeTagGroups = () =>
      buildMergeTagGroups({ website, fields, actions });

    if (!FroalaEditor.DEFAULTS.htmlAllowedEmptyTags.includes(".cf-merge-chip-remove")) {
      FroalaEditor.DEFAULTS.htmlAllowedEmptyTags.push(".cf-merge-chip-remove");
    }

    FroalaEditor.PLUGINS.mergeTagChips = function (editor) {
      const chipify = () => chipifyMergeTags(editor.el, mergeTagGroups);
      const handleChipClick = (target) => {
        const chip = target?.closest?.(".cf-merge-chip");
        if (!chip) return;
        if (target.closest(".cf-merge-chip-remove")) {
          removeMergeTagChip(editor, chip);
          editor.events.focus();
        } else {
          openMergeTagChipPopover(editor, chip, mergeTagGroups(), website);
        }
      };
      return {
        _init: function () {
          // The click that starts canvas editing marks its target #selected before init.
          editor.events.on("initialized", function () {
            chipify();
            handleChipClick(editor.el.querySelector("#selected"));
          });
          editor.events.on("html.set", chipify);
          editor.events.on("toolbar.show", () => !isMergeTagChipPopoverOpen(editor));
          editor.events.on("html.get", unchipifyMergeTags);
          editor.events.$on(editor.$el, "click", (e) => handleChipClick(e.target));
        },
      };
    };

    FroalaEditor.DefineIcon("personalize", { NAME: "person" });
    FroalaEditor.RegisterCommand("personalize", {
      title: "Merge tags",
      focus: true,
      icon:
        '<span style="width: 13px; margin-top: 7px; font-size: 12px !important; float: initial !important; margin-left: 0px !important; margin-right: 0px !important;" class="glyphicon glyphicon-user center" aria-hidden="true"></span>',
      callback: function () {
        openMergeTagPicker(this, mergeTagGroups(), website);
      },
    });

    // Register the line height command.
    FroalaEditor.RegisterCommand('lineHeight', {
      type: 'dropdown',
      title: 'Line Height',
      options: {
        'inherit': 'inherit',
        '10px': '10px',
        '20px': '20px',
        '30px': '30px',
        '40px': '40px',
        '50px': '50px',
        '60px': '60px',
        '70px': '70px',
        '80px': '80px',
        '90px': '90px',
        '100px': '100px',
        '110px': '110px',
        '120px': '120px',
        '130px': '130px',
        '140px': '140px',
        '150px': '150px',
      },
      plugin: 'lineHeight',
      callback: function (cmd, val) {
        this.lineHeight.apply(val);
      }
    });

    // Define an icon.
    FroalaEditor.DefineIcon("customHTML", { NAME: "star" });

    // Define a button.
    FroalaEditor.RegisterCommand("customHTML", {
      // Button title.
      title: "Custom HTML",

      // Specify the icon for the button.
      // If this option is not specified, the button name will be used.
      icon: '<div style="white-space: nowrap;"><span style="width: 8px; margin: 3px 0px 0px 0px !important; font-size: 8px !important; padding: 0px !important; min-width: 0;" class="glyphicon glyphicon-menu-left" aria-hidden="true"></span><span style="width: 8px; margin: 3px 0px 0px 0px !important; font-size: 8px !important; min-width: 0; padding: 0px !important; min-width: 0" class="glyphicon glyphicon-menu-right" aria-hidden="true"></span></div>',

      // Save the button action into undo stack.
      undo: true,

      // Focus inside the editor before the callback.
      focus: true,

      // Show the button on mobile or not.
      showOnMobile: true,

      // Refresh the buttons state after the callback.
      refreshAfterCallback: true,

      // Called when the button is hit.
      callback: function () {},

      // Called when the button state might have changed.
      refresh: function ($btn) {
        // The current context is the editor instance.
        // console.log (this.selection.element());
      },
    });

    // Define an icon.
    FroalaEditor.DefineIcon("filestack", { NAME: "image", SVG_KEY: 'image'  });

    // Define a button.
    FroalaEditor.RegisterCommand("filestack", {
      title: "Insert Image",
      icon: '<span style="margin-top: 3px; font-size: 12px !important; float: initial !important;" class="glyphicon glyphicon-picture center" aria-hidden="true"></span>',
      undo: true,
      focus: true,
      showOnMobile: true,
      refreshAfterCallback: true,
      callback: function () {
        this.selection.save();

        uploads.select("froala", {
          froala: this,
          environment: environment,
          path: "/websites/" + website.id + "/",
          cursor: this.selection.element(),
          website_id: website.id,
          library: true,
        });
      },

      // Called when the button state might have changed.
      refresh: function ($btn) {
        // The current context is the editor instance.
        // console.log (this.selection.element());
      },
    });

    FroalaEditor.DefineIcon("filestackReplace", { NAME: "image" });
    FroalaEditor.RegisterCommand("filestackReplace", {
      title: "Replace Image",
      icon: '<span style="margin-top: 3px; font-size: 12px !important; float: initial !important;" class="glyphicon glyphicon-picture center" aria-hidden="true"></span>',
      focus: false,
      undo: true,
      refreshAfterCallback: true,
      callback: function () {
        this.events.disableBlur();

        uploads.select("froala_replace", {
          froala: this,
          image: this.image.get(),
          environment: environment,
          path: "/websites/" + website.id + "/",
          website_id: website.id,
          library: true,
        });
      },
    });
    
  }
  return FroalaEditor;
};

export default froalaExtend;
